<script lang="ts">
  import { userbaseStore } from "../../stores/stores";
  import { createEventDispatcher, onMount } from "svelte";
  import Button from "../../shared/Button.svelte";
  import Input from "../../shared/Input.svelte";
  import type { Entry } from "../../stores/types";
  import moment from "moment";

  export let inventoryItem: Entry, itemId: string;
  let dispatch = createEventDispatcher();
  let updatePromise = null;
  let databaseName = "inventory";
  let fieldDate = moment().format("yyyy-MM-DD");

  const submitHandler = () => {
    updatePromise = $userbaseStore.updateItem({
      databaseName,
      itemId,
      inventoryItem,
    });
    inventoryItem.lastUsed = new Date(fieldDate);
    dispatch("updateItem");
    var logItem = {
      action: "update-adjust",
      changedItem: inventoryItem,
    };
    updatePromise = $userbaseStore.insertItem({
      databaseName: "logs",
      item: logItem,
    });
  };
</script>

<form class="form" on:submit|preventDefault={submitHandler}>
  <h2>Menge anpassen</h2>
  <Input
    label="Name"
    value={inventoryItem.article.item.name}
    type="text"
    disabled
  />
  <Input
    label="Menge"
    bind:value={inventoryItem.amount}
    type="number"
    required
  />
  <Input label="angepasst am" bind:value={fieldDate} type="date" required />
  <Button type="secondary" flat={true}>Eintrag korrigieren</Button>
</form>
